import styled, { keyframes } from 'styled-components';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const scrollReveal = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const ContactScholarContainer = styled.section`
  width: 100%;
  padding: 120px 0;
  background: #FFFAF2;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
  position: relative;
  z-index: 1;
  animation: ${scrollReveal} 1s ease-out;

  @media (max-width: 1024px) {
    gap: 60px;
    padding: 0 32px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 0 32px;
    text-align: center;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeInUp} 0.8s ease-out 0.6s both;
  transition: transform 0.1s ease-out, opacity 0.1s ease-out;
  will-change: transform, opacity;

  @media (max-width: 768px) {
    order: -1;
  }
`;

export const PlaceholderImage = styled.img`
  width: 100%;
  max-width: 484px;
  height: auto;
  transition: transform 0.4s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) {
    max-width: 400px;
  }

  @media (max-width: 768px) {
    max-width: 350px;
  }

  @media (max-width: 480px) {
    max-width: 300px;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 550px;
  transition: transform 0.1s ease-out, opacity 0.1s ease-out;
  will-change: transform, opacity;

  @media (max-width: 768px) {
    max-width: none;
    margin: 0 auto;
  }
`;

export const Title = styled.h2`
  font-family: 'Sora', 'Mulish', 'Helvetica', sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  color: #1B170C;
  margin: 0;
  letter-spacing: -0.02em;
  animation: ${fadeInUp} 0.8s ease-out 0.2s both;

  @media (max-width: 1024px) {
    font-size: 42px;
  }

  @media (max-width: 768px) {
    font-size: 36px;
    line-height: 1.3;
  }

  @media (max-width: 480px) {
    font-size: 32px;
  }

  @media (max-width: 360px) {
    font-size: 28px;
  }
`;

export const Description = styled.p`
  font-family: 'Sora', 'Mulish', 'Helvetica', sans-serif;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.7;
  color: #393324;
  margin: 0;
  animation: ${fadeInUp} 0.8s ease-out 0.4s both;

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 1.8;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;
